import fileApi from "@/api/file";

const actions = {
  async list({ commit, state }, params) {
    commit("setFileListLoader", true);
    state.loadingPromise = fileApi
      .list(params)
      .then(fileList => {
        commit("updateFileList", fileList.data);
        commit("setFileListLoader", false);
      })
      .catch(e => {
        console.error(e);
        commit("setFileListLoader", false);
      });
  },
  async remove({ dispatch }, data) {
    const { fileId, ownerId, ownerType } = data;
    await fileApi.remove(fileId);
    await dispatch("list", {
      ownerId,
      ownerType,
    });
  },
  resetList({ commit }) {
    commit("resetList");
  },
};

const mutations = {
  resetList(state) {
    state.fileList = [];
  },
  setFileListLoader(state, isLoading) {
    state.isLoadingFileList = isLoading;
  },
  updateFileList(state, fileList) {
    state.fileList = fileList;
  },
};

const getters = {};

const state = {
  isLoadingFileList: false,
  loadingPromise: null,
  fileList: [],
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
